var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkTc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3218_158835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6668 8.66795C6.9531 9.0507 7.31837 9.3674 7.73783 9.59657C8.1573 9.82574 8.62114 9.96202 9.0979 9.99617C9.57466 10.0303 10.0532 9.96152 10.501 9.79447C10.9489 9.62741 11.3555 9.36599 11.6935 9.02795L13.6935 7.02795C14.3007 6.39927 14.6366 5.55726 14.629 4.68328C14.6215 3.80929 14.2709 2.97324 13.6529 2.35522C13.0348 1.73719 12.1988 1.38663 11.3248 1.37903C10.4508 1.37144 9.60881 1.70742 8.98013 2.31461L7.83347 3.45461M9.33347 7.33461C9.04716 6.95186 8.68189 6.63516 8.26243 6.40599C7.84297 6.17681 7.37913 6.04053 6.90237 6.00639C6.4256 5.97225 5.94708 6.04103 5.49924 6.20809C5.0514 6.37515 4.64472 6.63657 4.3068 6.97461L2.3068 8.97461C1.69961 9.60329 1.36363 10.4453 1.37122 11.3193C1.37881 12.1933 1.72938 13.0293 2.3474 13.6473C2.96543 14.2654 3.80147 14.6159 4.67546 14.6235C5.54945 14.6311 6.39146 14.2951 7.02013 13.6879L8.16013 12.5479",
    stroke: "#545454",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3218_158835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTc);
export default __webpack_public_path__ + "static/media/linkTc.6267adb32dbed16edb9ec3e506aff81a.svg";
export { ForwardRef as ReactComponent };